/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Scanner_Scan_AllInputs */

const en_portal_scanner_scan_all = /** @type {(inputs: Portal_Scanner_Scan_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan All Boards`)
};

const de_portal_scanner_scan_all = /** @type {(inputs: Portal_Scanner_Scan_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan All Boards`)
};

const fr_portal_scanner_scan_all = /** @type {(inputs: Portal_Scanner_Scan_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan All Boards`)
};

const es_portal_scanner_scan_all = /** @type {(inputs: Portal_Scanner_Scan_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan All Boards`)
};

const it_portal_scanner_scan_all = /** @type {(inputs: Portal_Scanner_Scan_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan All Boards`)
};

const nl_portal_scanner_scan_all = /** @type {(inputs: Portal_Scanner_Scan_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan All Boards`)
};

const pl_portal_scanner_scan_all = /** @type {(inputs: Portal_Scanner_Scan_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan All Boards`)
};

const fi_portal_scanner_scan_all = /** @type {(inputs: Portal_Scanner_Scan_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan All Boards`)
};

const da_portal_scanner_scan_all = /** @type {(inputs: Portal_Scanner_Scan_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan All Boards`)
};

const sv_portal_scanner_scan_all = /** @type {(inputs: Portal_Scanner_Scan_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan All Boards`)
};

/**
* | output |
* | --- |
* | "Scan All Boards" |
*
* @param {Portal_Scanner_Scan_AllInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const portal_scanner_scan_all = /** @type {((inputs?: Portal_Scanner_Scan_AllInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Scanner_Scan_AllInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_portal_scanner_scan_all(inputs)
	if (locale === "fr") return fr_portal_scanner_scan_all(inputs)
	if (locale === "es") return es_portal_scanner_scan_all(inputs)
	if (locale === "it") return it_portal_scanner_scan_all(inputs)
	if (locale === "nl") return nl_portal_scanner_scan_all(inputs)
	if (locale === "pl") return pl_portal_scanner_scan_all(inputs)
	if (locale === "fi") return fi_portal_scanner_scan_all(inputs)
	if (locale === "da") return da_portal_scanner_scan_all(inputs)
	if (locale === "sv") return sv_portal_scanner_scan_all(inputs)
	return en_portal_scanner_scan_all(inputs)
});